// CloserAI CDN Asset URLs
export const CDN = {
  logo: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/closerai_logo_3a156df5.png",
  heroBg: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/hero_bg_263cac8c.png",
  personaCfo: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/persona_cfo_224020ed.png",
  personaExecutive: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/persona_executive_1552bab2.png",
  personaShopper: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/persona_shopper_1feee183.png",
  personaGatekeeper: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/persona_gatekeeper_859566aa.png",
  personaChampion: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/persona_champion_fc16c362.png",
  dashboardPreview: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/dashboard_preview_516eba77.png",
  chatPreview: "https://d2xsxph8kpxj0f.cloudfront.net/310519663465552488/HmLijjfneUceHKDyczJt4M/chat_preview_2ebe0bf3.png",
} as const;

// Subscription tier limits
export const TIER_LIMITS = {
  free: { sessionsPerMonth: 3, industries: 1 },
  pro: { sessionsPerMonth: Infinity, industries: 5 },
  team: { sessionsPerMonth: Infinity, industries: 5 },
} as const;

// Industries
export const INDUSTRIES = ["saas", "real_estate", "insurance", "retail", "automotive"] as const;
export type Industry = typeof INDUSTRIES[number];

export const INDUSTRY_LABELS: Record<Industry, string> = {
  saas: "SaaS Sales",
  real_estate: "Real Estate",
  insurance: "Insurance",
  retail: "Retail / B2C",
  automotive: "Automotive",
};

// Scenario types
export const SCENARIO_TYPES = ["cold_call", "discovery", "demo", "negotiation", "closing", "objection_handling"] as const;
export type ScenarioType = typeof SCENARIO_TYPES[number];

export const SCENARIO_TYPE_LABELS: Record<ScenarioType, string> = {
  cold_call: "Cold Call",
  discovery: "Discovery",
  demo: "Demo",
  negotiation: "Negotiation",
  closing: "Closing",
  objection_handling: "Objection Handling",
};

// Difficulty levels
export const DIFFICULTIES = ["beginner", "intermediate", "advanced"] as const;
export type Difficulty = typeof DIFFICULTIES[number];

export const DIFFICULTY_LABELS: Record<Difficulty, string> = {
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
};

// Score dimensions
export const SCORE_DIMENSIONS = [
  { key: "rapport", label: "Rapport", color: "#00D4FF" },
  { key: "discovery", label: "Discovery", color: "#22C55E" },
  { key: "objectionHandling", label: "Objection Handling", color: "#F59E0B" },
  { key: "valueProp", label: "Value Proposition", color: "#8B5CF6" },
  { key: "closing", label: "Closing", color: "#EF4444" },
  { key: "professionalism", label: "Professionalism", color: "#06B6D4" },
] as const;

// Pricing
export const PRICING = {
  free: { price: 0, label: "Free", description: "Get started with sales practice" },
  pro: { price: 2900, label: "Pro", description: "Unlimited practice for serious closers" },
  team: { price: 4900, label: "Team", description: "Train your entire sales team" },
} as const;
